import { checkElementInViewport } from './checkElementInViewport';
import throttle from 'lodash/throttle';

export interface IObserverParams {
  target: HTMLElement;
  threshold: number;
  onVisible(): void;
}

export const intersectionObserver = (params: IObserverParams) => {
  const { target, threshold, onVisible } = params;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          onVisible();
        }
      });
    },
    { threshold },
  );

  observer.observe(target);

  return () => {
    observer.disconnect();
  };
};

export const scrollObserver = (params: IObserverParams) => {
  const { target, threshold, onVisible } = params;
  let isElementInViewport = checkElementInViewport(target, threshold);

  if (isElementInViewport) {
    onVisible();
  }

  const checkVisibility = throttle(() => {
    const isElementInViewportNow = checkElementInViewport(target, threshold);

    if (isElementInViewportNow && !isElementInViewport) {
      onVisible();
    }

    isElementInViewport = isElementInViewportNow;
  }, 300);

  window.addEventListener('resize', checkVisibility);
  document.addEventListener('scroll', checkVisibility);

  return () => {
    window.removeEventListener('resize', checkVisibility);
    document.removeEventListener('scroll', checkVisibility);
  };
};

export const getObserver = () => {
  return 'IntersectionObserver' in window ? intersectionObserver : scrollObserver;
};
